import { SxProps, Theme } from "@mui/material";

export const bpmnDiagramThemeSx: SxProps<Theme> = {
  bgcolor: (theme) =>
    theme.palette.mode === "dark" ? "#000000" : theme.palette.background.paper,
  color: "text.primary",
  "& .djs-container, & .viewport, & svg": {
    background: (theme) =>
      theme.palette.mode === "dark" ? "#000000 !important" : "transparent !important",
  },
  "& .djs-shape .djs-visual > rect, & .djs-shape .djs-visual > circle, & .djs-shape .djs-visual > ellipse, & .djs-shape .djs-visual > polygon": {
    fill: (theme) =>
      theme.palette.mode === "dark" ? "#000000 !important" : undefined,
    stroke: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
  },
  "& .djs-shape.new-parent .djs-visual > :nth-child(1), & .djs-shape.drop-not-ok .djs-visual > :nth-child(1)": {
    fill: (theme) =>
      theme.palette.mode === "dark" ? "#000000 !important" : undefined,
  },
  "& svg.new-parent, & svg.drop-not-ok": {
    background: (theme) =>
      theme.palette.mode === "dark" ? "transparent !important" : undefined,
  },
  "& .djs-shape .djs-visual path, & .djs-shape .djs-visual line, & .djs-shape .djs-visual polyline": {
    stroke: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
  },
  "& .djs-shape .djs-visual path[fill='black'], & .djs-shape .djs-visual path[fill='#000'], & .djs-shape .djs-visual path[fill='#000000']": {
    fill: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
  },
  "& .djs-connection .djs-visual path, & .djs-connection .djs-visual line, & .djs-connection .djs-visual polyline": {
    stroke: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
  },
  "& marker path, & marker polygon, & marker polyline, & marker rect, & marker circle": {
    fill: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
    stroke: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
  },
  "& marker [fill='none']": {
    fill: (theme) =>
      theme.palette.mode === "dark" ? "none !important" : undefined,
  },
  "& marker [fill='black'], & marker [fill='#000'], & marker [fill='#000000'], & marker [stroke='black'], & marker [stroke='#000'], & marker [stroke='#000000']": {
    fill: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
    stroke: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.grey[300]} !important` : undefined,
  },
  "& .djs-label text, & .djs-shape text, & .djs-shape tspan, & .djs-connection text": {
    fill: (theme) =>
      theme.palette.mode === "dark" ? `${theme.palette.text.primary} !important` : undefined,
  },
};
